module.exports = require('./convert')(
  ".exportsfunc',/;<>[]abdghijklmqvwyz{}",
  "ץקספםראדכומב,ת.ף><][שנגעיןחלךצ/ה'טז}{"
)
